export const db=[
	{
		article:'KNK-SN-9011',
		name:'PRIMER Комплект нивелирующий ONFLOOR IEK',
		showTable:true,
	},
	{
		article:'KNL-57-12-7012',
		name:'PRIMER Лючок напольный ONFLOOR 12 IEK',
		showTable:true,
		assortment: 2
	},
	{
		article:'KNL-80-16-7012',
		name:'PRIMER Лючок напольный ONFLOOR 24 IEK',
		showTable:true,
		assortment: 1
	},
	{
		article:'KNP-80-16-PA-7012',
		name:'PRIMER Коробка приборная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-00-7012',
		name:'PRIMER Заглушка приборная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-03-7012',
		name:'PRIMER Рамка приборная на 3 места клас. ЭУИ ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-45-7012',
		name:'PRIMER Рамка приборная на 8 модулей ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNU-06-PCB',
		name:'PRIMER Лючок напольный ONFLOOR 6 mini B IEK',
		showTable:true,
		assortment: 1
	},
	{
		article:'KNU-06-PCL',
		name:'PRIMER Лючок напольный ONFLOOR 6 mini L IEK',
		showTable:true,
		assortment: 1
	},
	{
		article:'KNU-12-PA-9011',
		name:'PRIMER Коробка напольная ONFLOOR 12 IEK',
		showTable:true,
	},
	{
		article:'KNU-80-16-PA-9011',
		name:'PRIMER Коробка напольная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'PM-LN10-00-K03',
		name:'PRIMER Лючок напольный ONFLOOR закрытый (глухая крышка) IEK',
		showTable:true,
	},
	{
		article:'PM-LN10D-RP-12-K03',
		name:'PRIMER Рамка приборная на 12 модулей ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'PM-LN43-02-O-44-K50',
		name:'PRIMER Лючок в бетонный пол с коробкой и установочным комплектом на 2 модуля IP44 матовый никель IEK',
		showTable:true,
		assortment: 1
	},
	{
		article:'PM-LN21-03-O-42-K46',
		name:'PRIMER Лючок с откидной крышкой неукомплектованный на 3 модуля IP42 нержавеющая сталь IEK',
		showTable:true,
		assortment: 3
	},
	{
		article:'PM-LN12-08-O-20-K02',
		name:'PRIMER Лючок напольный на 8 модулей IEK',
		showTable:true,
		assortment: 2
	},
	{
		article:'PM-KN10-08-18-M-K03',
		name:'PRIMER Коробка напольная металлическая для лючка на 8 модулей высота 108мм IEK',
		showTable:true,
	},
]

// Аксессуары (коробки, рамки, заглушки, нивелирующий комплект)
export const accessoriesDb=[
	{
		article:'KNK-SN-9011',
		name:'PRIMER Комплект нивелирующий ONFLOOR IEK',
		showTable:true,
	},
	{
		article:'KNP-80-16-PA-7012',
		name:'PRIMER Коробка приборная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-00-7012',
		name:'PRIMER Заглушка приборная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-03-7012',
		name:'PRIMER Рамка приборная на 3 места клас. ЭУИ ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNR-80-45-7012',
		name:'PRIMER Рамка приборная на 8 модулей ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'KNU-12-PA-9011',
		name:'PRIMER Коробка напольная ONFLOOR 12 IEK',
		showTable:true,
	},
	{
		article:'KNU-80-16-PA-9011',
		name:'PRIMER Коробка напольная ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'PM-LN10D-RP-12-K03',
		name:'PRIMER Рамка приборная на 12 модулей ONFLOOR 24 IEK',
		showTable:true,
	},
	{
		article:'PM-KN10-08-18-M-K03',
		name:'PRIMER Коробка напольная металлическая для лючка на 8 модулей высота 108мм IEK',
		showTable:true,
	},
]

// Лючки
export const hatchDb=[
	{
		article:'KNL-57-12-7012',
		name:'PRIMER Лючок напольный ONFLOOR 12 IEK',
		showTable:true,
		assortment: 2,
	},
	{
		article:'KNL-80-16-7012',
		name:'PRIMER Лючок напольный ONFLOOR 24 IEK',
		showTable:true,
		assortment: 1,
	},
	{
		article:'KNU-06-PCB',
		name:'PRIMER Лючок напольный ONFLOOR 6 mini B IEK',
		showTable:true,
		assortment: 1,
	},
	{
		article:'KNU-06-PCL',
		name:'PRIMER Лючок напольный ONFLOOR 6 mini L IEK',
		showTable:true,
		assortment: 1,
	},
	{
		article:'PM-LN10-00-K03',
		name:'PRIMER Лючок напольный ONFLOOR закрытый (глухая крышка) IEK',
		showTable:true,
	},
	{
		article:'PM-LN43-02-O-44-K50',
		name:'PRIMER Лючок в бетонный пол с коробкой и установочным комплектом на 2 модуля IP44 матовый никель IEK',
		showTable:true,
		assortment: 1,
	},
	{
		article:'PM-LN21-03-O-42-K46',
		name:'PRIMER Лючок с откидной крышкой неукомплектованный на 3 модуля IP42 нержавеющая сталь IEK',
		showTable:true,
		assortment: 3,
	},
	{
		article:'PM-LN12-08-O-20-K02',
		name:'PRIMER Лючок напольный на 8 модулей IEK',
		showTable:true,
		assortment: 2,
	},
]


// WEBPACK FOOTER //
// ./src/react/constants/hatch/db.js